import { EnrolState } from 'enum'
import { sortTableEnum } from 'enum/sortTable.enum'
import { ExternalCourseEnrolled } from 'models/externalCoursesEnrolled.model'
import api from '..'

export interface GetListResponse {
  data: ExternalCourseEnrolled[]
  total: number
  perPage: number
}

export interface ExternalCoursesEnrolledListSort {
  field?: string
  order?: sortTableEnum
}

export interface ExternalCoursesEnrolledListParams {
  page?: number
  searchText?: string
  sort?: ExternalCoursesEnrolledListSort
  state?: EnrolState | null
  perPage?: number
}

const externalCoursesEnrolledList = (
  params?: ExternalCoursesEnrolledListParams
) => {
  const {
    page = 1,
    searchText,
    sort,
    perPage = 50,
    state,
  } = {
    ...params,
  }
  const q = { s: '', g: [{}] } as any
  const { field, order } = { ...sort }
  q['s'] = (field && order && [`${field} ${sortTableEnum[order]}`]) || [
    'created_at desc',
  ]
  q['m'] = 'and'
  q['external_course_name_cont'] = searchText
  if (state !== null) q['state_eq'] = state

  return api
    .post(`external_courses_enrolled/search`, { page, perPage, q })
    .then<GetListResponse>(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default externalCoursesEnrolledList
